/**
 *
 * Asynchronously loads the component for Candidato
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Candidate/Loadable.js